
// import Asb3Sender from 'razlet-sdk/lib/api/asb3-sender';
import yandexMetrikaEvent from 'razlet-sdk/lib/metrik/yandex';

export default {
  name: 'schedule-table',
  props: {
    list: {
      type: Array,
      default: () => [],
    },
    request: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      selectedItem: null,
    };
  },
  methods: {
    goToVariants({flight = {}, day = {}}) {
      // this.$bus.$emit('add-removable-notification', {theme: 'error', text: 'Покупка билетов в настоящий момент недоступна'});
      yandexMetrikaEvent(process.env.ymSiteId, 'open-aff-from-schedule');
      window.location.href = `/sale?flightSearch=${flight.fromCityCode}${day.day}${day.month}${flight.toCityCode}1`;
      /* Asb3Sender().post('/api/web/pricing/only-id', {
        class: 'economy',
        rtIndex: 0,
        passengers: {
          aaa: 1,
          rbg: 0,
          rmg: 0,
          ins: 0,
        },
        segments: [
          {
            from: flight.fromCityCode,
            to: flight.toCityCode,
            date: `${day.year}-${day.month}-${day.day}`,
          },
        ],
      }).then(res => {
        setTimeout(() => {
          if (res.data.uid) window.location.href = `/sale#/variants/${res.data.uid}?search=${flight.fromCityCode}${day.day}${day.month}${flight.toCityCode}1000es`;
          else this.$bus.$emit('add-removable-notification', {theme: 'error', text: 'Рейсы на эту дату не найдены. Выберите актуальную дату'});
        });
      }); */
    },
  },
};
